export default "__VITE_ASSET__1qQsn9W2__"